<template>
    <div class="location-edit">
        <Header :app="app" :left="true" :title="app.selectedLocation.name">
            <template v-slot:left>
                <a href="javascript:;" v-on:click="app.$router.go(-1)">
                    &laquo;
                </a>
            </template>
        </Header>

        <div class="content">
            <div class="field">
                <label>Location Name</label>
                <input type="text" v-model="newName" v-on:blur="changeName()" autofocus>
            </div>

            <div class="field">
                <button v-on:click="app.remove(app.locations, app.selectedLocation, 'location', true)" class="full-width button-small button-gray">
                    Delete This Location
                </button>
            </div>

            <!-- <pre>
                How often does this location meet?
                Repeats weekly [choose days]
                Repeats monthly [choose dates]
            </pre> -->
        </div>
    </div>
</template>

<script>
import Header from '@/components/header/component.vue';

export default {
    name: 'locationEdit',
    components: {
        Header
    },
    props: ['app'],
    data() {
        return {
            newName: ''
        };
    },
    watch: {
        'app.selectedLocation': function() {
            var _ = this;

            if (!_.app.selectedLocation) {
                _.$router.push('/');
            }
        }
    },
    mounted() {
        var _ =  this;

        _.newName = _.app.selectedLocation.name;
    },
    methods: {
        changeName() {
            var _ = this;

            _.app.selectedLocation.name = _.newName;
            _.app.save(_.app.selectedLocation, 'name');
        }
    }
};
</script>
